import React from "react";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { navigationIds } from "../../../analyticsTags";
import { RootState } from "../../../reducers";
import { loadPageData } from "../../../actions/cms";
import "./styles.scss";
import { fetchProfileZipCode } from "../../../api/cms/api";
import StationModal from "./StationModal";
let dropdown_view = false;
let _profile: any;
const WatchJoin: React.FC<any> = ({
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  joinData,
  loginData,
}) => {
  if (profile !== undefined) {
    _profile = profile;
  }
  // _profile = ((profile) ? profile : null);
  return (
    <>
      {isLoggedIn ? (
        <>
          <p className="hello">
            Hello, {_profile ? _profile.firstName : "test"}
          </p>{" "}
          <span/>{" "}
          <a
            className={"hello"}
            id={navigationIds.navigationLogout}
            href="/"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              dropdown_view = !dropdown_view;
              if (dropdown_view) {
                document
                  .getElementsByClassName("dropdown-user-options")[0]
                  .classList.add("dropdown-block");
                document
                  .getElementsByClassName("dropdown-user-options")[1]
                  .classList.add("dropdown-block");
              } else {
                document
                  .getElementsByClassName("dropdown-user-options")[0]
                  .classList.remove("dropdown-block");
                document
                  .getElementsByClassName("dropdown-user-options")[1]
                  .classList.remove("dropdown-block");
              }
            }}
          >
            <p className="user-spin-id">
              SPIN ID <samp>{_profile ? _profile.spinID : ""}</samp>
            </p>
          </a>
          <div className={"dropdown-user-options"}>
            <div className="spin-id-check">
              <p className="my-spin-id">
                <a href={window.location.origin + "/wheel-watchers/my-spin-id"}>
                  Did My SPIN ID Win?
                </a>
              </p>

              <a href={window.location.origin + "/wheel-watchers/my-spin-id"}>Check</a>
            </div>

            <div className="content">
              <div>
                <div className="gigya-raas">
                  <span
                    className="gigya-raas"
                    style={{ display: "inline" }}
                  />
                  <span
                    className="gigya-raas"
                    style={{ display: "inline" }}
                  />
                  <span className="gigya-raas">
                    <a href="/wheel-watchers/edit-profile">Profile</a>
                    or
                    <a
                      href="/react/logout"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onLogOut();
                      }}
                    >
                      Log Out
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <p>Wheel Watchers Club SPIN ID </p>
          <a
            id={navigationIds.navigationLogin}
            href="/"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onLogIn();
            }}
          >
            {loginData ? loginData.login_link_text : "Login"}
          </a>{" "}
          or{" "}
          <a
            id={navigationIds.navigationJoin}
            href={
              window.location.origin + (joinData ? joinData.join_link : "/")
            }
          >
            {joinData ? joinData.join_link_text : "Join Now"}
          </a>
        </>
      )}
    </>
  );
};

export const JoinWheelWatchers: React.FC<any> = ({
  joinHtml = "",
  isMobile,
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  joinData,
  loginData,
}) => {
  return !isMobile ? (
    <div
      className={
        isLoggedIn
          ? "col-12 col-lg-5 d-none d-lg-block text-right header-top-right user-login"
          : "col-12 col-lg-5 d-none d-lg-block text-right header-top-right"
      }
    >
      <WatchJoin
        onJoin={onJoin}
        onLogIn={onLogIn}
        isLoggedIn={isLoggedIn}
        onLogOut={onLogOut}
        profile={profile}
        loginData={loginData}
        joinData={joinData}
      />
    </div>
  ) : (
    <div
      className={
        isLoggedIn
          ? "col-6 d-flex align-items-center align-items-end-md justify-content-end d-lg-none mobile-view user-login"
          : "col-6 d-flex align-items-center align-items-end-md justify-content-end d-lg-none mobile-view"
      }
    >
      <div className="text-right header-top-right">
        <WatchJoin
          onJoin={onJoin}
          onLogIn={onLogIn}
          isLoggedIn={isLoggedIn}
          onLogOut={onLogOut}
          profile={profile}
          loginData={loginData}
          joinData={joinData}
        />
      </div>
    </div>
  );
};

const HeaderTopBar: React.FC<any> = ({
  watchHtml = "",
  joinHtml = "",
  removeBg,
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  loginData,
  joinData,
  stationHTML,
  station_data_notstation,
}) => {
  const [showStationModal, setStationModal] = useState(false);
  const [StationZipCode, setStationZipCode] = useState("");
  const [StationDataResponse, setStationDataResponse] = useState(null);
  const [StationHTML, setStationHTML] = useState("");
  const [StationDataResponseTemp, setStationDataResponseTemp] = useState(null);
  const [StationHTMLTemp, setStationHTMLTemp] = useState("");
  useEffect(() => {
    if (stationHTML) {
      setStationHTML(stationHTML);
    }
  }, [stationHTML]);

  const openModal = () => {
    setStationModal(true);
  };
  const selectButton = async () => {
    setStationModal(false);
    // setStationDataResponse(StationDataResponseTemp);
    setStationHTML(StationHTMLTemp);
    // const json = await fetchProfileZipCode(StationZipCode);
    // if (json.header.station_data != '' && json.header.station_data != undefined) {
    //   var tuneInData = {
    //     tune_in_time: json.header.station_data.tune_in_info,
    //     station_name: json.header.station_data.station_name
    //   }
    //   document.cookie =
    //       "wof_react_station_data=" +
    //       JSON.stringify(tuneInData) +
    //       "; expires=Thu, 18 Dec 2050 12:00:00 UTC; path=/";
    // }
  };

  const submitZipCode = async () => {
    const json = await fetchProfileZipCode(StationZipCode);
    setStationDataResponse(json.header.station_data);
    setStationHTMLTemp(json.header.station_data_html);
  };
  return (
    <section className={`header-top${removeBg ? " remove-bg" : ""}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-xlg-12 col-lg-7 header-top-left">
            <div id="tune-in-info-data">
              <span dangerouslySetInnerHTML={{ __html: StationHTML }}/>
                <a href="/watch">Find Your Station</a>
            </div>
          </div>

          <JoinWheelWatchers
            joinHtml={joinHtml}
            onJoin={onJoin}
            onLogIn={onLogIn}
            isLoggedIn={isLoggedIn}
            onLogOut={onLogOut}
            profile={profile}
            loginData={loginData}
            joinData={joinData}
          />
          <StationModal
            show={showStationModal}
            img={StationZipCode}
            description={StationDataResponse}
            onHide={() => setStationModal(false)}
            onChange={setStationZipCode}
            onClose={submitZipCode}
            onSelect={selectButton}
          />
        </div>
      </div>
    </section>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchSiteData: () => dispatch(loadPageData()),
});

const mapStateToProps = (state: RootState) => ({
  header: state.site.header,
  isLoggedIn: state.auth.isLoggedIn,
  profile: state.auth.profile,
});

HeaderTopBar.defaultProps = {
  fetchSiteData: () => {},
  header: {},
};

export { HeaderTopBar };

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTopBar);
